import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  InputType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_151_vehicle_make: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Vehicle make",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "vehiclemake",
        TableName: "lookup_name",
        DisplayName: "Vehicle make",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: ComponentType.TEXT_FIELD,
            IncludeLabel: true,
            Label: "Name",
            name: "txt_name",
            BindValue: "txt_name",
            Json_Attribute: "name",
            disabled: false,
            inputType: InputType.TEXT,
            showInSummary: true,
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "vehiclemake_items",
            label: "Items",
            tableName: "lookup_items",
            BindValue: "sub_lookupitem",
            enableSearch: true,
            addButtonPosition: "top",
            childControls: [
              {
                IncludeLabel: true,
                Label: "Sub Name",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_subName",
                Json_Attribute: "name",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
            ],
          },
        ],
      },
      {
        componentType: LayoutTypes.GROUP,
        style: {
          direction: FlexDirection.ROW,
          gap: 0,
          marginTop: 10,
        },
        childComponents: [
          {
            componentType: ComponentType.BUTTON,
            name: "Submit",
            Label: "Submit",
            BindValue: "btn_submit",
            onPressAction: "save",
            ActionType: "Add",
            ScreenId: "151",
            style: {
              backgroundColor: "#22c55e",
              textColor: "#FFFFFF",
              padding: 12,
              borderRadius: 8,
            },
          },

        ],
      },
    ],
  },
];
